import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate, useNavigate  } from 'react-router-dom';
import { useEffect } from 'react';
import { DialogProvider } from './context/error-dialog-provider';

import './css/style.css';
import './App.css';

import ScheduleControl from './components/schedule-control';
import Login from './components/login';
import Users from './components/users';

import ErrorDialogController from './context/error-dialog-controller';

// 内部コンポーネントで useLocation を使う仕組み
function MainContent() {

  const navigate = useNavigate();

  useEffect(() => {
    ErrorDialogController.registerNavigate(navigate);
  }, [navigate]);

  return (
      <DialogProvider>
        <div className='App'>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/users" element={<Users />} />
            <Route path="/schedule" element={<ScheduleControl />} />
          </Routes>
        </div>
      </DialogProvider>
    
  );
}

function App() {
  return (
    <Router>
      <MainContent />
    </Router>
  );
}

export default App;